export const loginWebUrl = "/user/loginWeb";
